// Scroll tracking and management for search results

let lastScrollTime = 0;
let scrollTimeoutId = null;
const SCROLL_DETECTION_THRESHOLD_MS = 150; // Consider user actively scrolling if scroll happened within last 150ms

/**
 * Initialize scroll tracking
 */
export function initScrollTracking() {
    // Enable debug logging via URL parameter ?debugScrollRestore=1 or window.__debugScrollRestore = true
    const urlParams = new URLSearchParams(window.location.search);
    const debugParam = urlParams.get('debugScrollRestore');
    if (debugParam === '1' || debugParam === 'true') {
        window.__debugScrollRestore = true;
        console.log('[RenderResults] Debug logging enabled via URL parameter');
    }

    let scrollEventCount = 0;
    const handleScroll = () => {
        const now = Date.now();
        lastScrollTime = now;
        scrollEventCount++;
        
        if (window.__debugScrollRestore && scrollEventCount % 10 === 0) {
            console.log('[RenderResults] Scroll event:', {
                eventCount: scrollEventCount,
                timestamp: new Date(now).toISOString(),
                scrollTop: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
                documentHeight: document.documentElement.scrollHeight,
                windowHeight: window.innerHeight
            });
        }
        
        if (scrollTimeoutId) {
            clearTimeout(scrollTimeoutId);
        }
        // Reset after inactivity period
        scrollTimeoutId = setTimeout(() => {
            if (window.__debugScrollRestore) {
                console.log('[RenderResults] Scroll activity stopped');
            }
            lastScrollTime = 0;
        }, SCROLL_DETECTION_THRESHOLD_MS * 2);
    };
    
    // Start tracking when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            window.addEventListener('scroll', handleScroll, { passive: true });
        });
    } else {
        window.addEventListener('scroll', handleScroll, { passive: true });
    }
}

/**
 * Check if user is currently actively scrolling
 * @returns {boolean} True if user scrolled recently
 */
export function isUserScrolling() {
    const timeSinceLastScroll = Date.now() - lastScrollTime;
    const isScrolling = timeSinceLastScroll < SCROLL_DETECTION_THRESHOLD_MS;
    if (window.__debugScrollRestore) {
        console.log('[RenderResults] isUserScrolling:', {
            timeSinceLastScroll,
            threshold: SCROLL_DETECTION_THRESHOLD_MS,
            isScrolling,
            lastScrollTime: lastScrollTime ? new Date(lastScrollTime).toISOString() : 'never'
        });
    }
    return isScrolling;
}

export function getLastScrollTime() {
    return lastScrollTime;
}
